// HKDSE 2016 Paper 1 Knowledge Graph Samples - Complete Combined Set
// Merged from hkdse2016Samples_complete.js and hkdse2016Samples_complete_part2.js

import { hkdse2016Samples_complete } from './hkdse2016Samples_complete.js';
import { hkdse2016Samples_complete_part2 } from './hkdse2016Samples_complete_part2.js';

export const hkdse2016Samples_complete_combined = {
  ...hkdse2016Samples_complete,
  ...hkdse2016Samples_complete_part2
};

// Export individual parts for backward compatibility
export { hkdse2016Samples_complete, hkdse2016Samples_complete_part2 }; 